import React, { useMemo } from "react";
import Dropdown from "../DropDown";

interface MetricDropdownProps {
  selectedMetric: string;
  metrics: any[];
  onMetricChange: (selectedMetric: string) => void;
  disabled: boolean;
  className?: string;
  onFocus?: () => void;
}

const MetricDropdown: React.FC<MetricDropdownProps> = ({
  selectedMetric,
  metrics,
  onMetricChange,
  disabled,
  className = "",
  onFocus,
}) => {
  const options = useMemo(() => {
    return (metrics || [])
      .map((m: any) => {
        const name = m.metric_name ?? m.METRIC_NAME;
        return {
          value: name,
          label: name,
        };
      })
      .sort((a, b) =>
        a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
      ); // case-insensitive alphabetical sort
  }, [metrics]);
  

  return (
    <Dropdown
      options={options}
      selectedValue={selectedMetric}
      onValueChange={onMetricChange}
      disabled={disabled}
      className={className}
      placeholder="Select Metric"
      onFocus={onFocus}
    />
  );
};

export default MetricDropdown;
